module.exports = __webpack_public_path__ + "img/akasha.6957d991.png";